export default "/images/checkout-bg.png";